import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EStatus } from '../../models/EnumStatus';
import { Question } from '../../models/question.model';
import { EQuestionType, QuestionType } from 'src/app/models/questionType.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environment';
import { User } from 'src/app/models/user.model';
import { QuestionnaireCategory, QuestionnaireCategoryCountDto } from 'src/app/models/questionnaireCategory.model';
import { TranslateService } from '@ngx-translate/core';
import { UuidService } from 'src/app/services/uuid.service';
import { EImageStatus } from 'src/app/models/EnumImageStatus';
import { ChangeGuidRespons, mapGuids } from 'src/app/models/changeGuidsRespons';
import { TableFieldDto } from 'src/app/models/tableField.model';


@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  #httpservice = inject(HttpClient);
  #translate = inject(TranslateService);
  #uuidService = inject(UuidService);
  #baseUrl = environment.apiUrl;
  #specificUrl = `${this.#baseUrl}/global`

  public defaultQuestionHe: Question[] = [
    {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.Multi, name: "multi" }
      , optionsList: {
        guid: ""
        , answerOptionItem: [
          { guid: "", name: "", optionsListGuid: "" }]
      }
    },
    {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.Autocomplete, name: "autocomplete" }
      , optionsList: {
        guid: ""
        , answerOptionItem: [
          { guid: "", name: "", optionsListGuid: "" }]
      }
    },
    {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.Mark, name: "mark" }
      , optionsList: {
        guid: ""
        , answerOptionItem: [
          { guid: "", name: "", optionsListGuid: "" }]
      }
    },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.FreeText, name: "freeText" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Number, name: "number" } },
    {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.Table, name: "table" },
      columns: [
        { order: 1, title: "עמודה 1" },
        { order: 2, title: "עמודה 2" },
      ],
      rows: [
        { order: 1, title: "שורה 1" },
        { order: 2, title: "שורה 2" },
      ]
    },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.PhoneNumber, name: "phoneNumber" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Range, name: "range" }, fromNum: 1, toNum: 10 },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Title, name: "title" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Text, name: "text" }, },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Link, name: "link" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.UploadFile, name: "uploadfile" }, title: "לחץ להוספת קובץ או גרור קובץ לכאן" },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.UploadFileAdmin, name: "uploadfileAdmin" }, title: "לחץ להוספת קובץ או גרור קובץ לכאן" },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Fill, name: "fill" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Divider, name: "divider" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Date, name: "date" } },
    {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.QuestionsGroup, name: "questionsGroup" }, fromNum: 3,
      modularQuestions: [
        { guid: '', type: { id: EQuestionType.Fill, name: "fill", en: "Fill In the Blank", title: "שדה מילוי" , image:"fill.svg" }, status: EStatus.Created, }
      ]
    },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Signature, name: "signature" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Image, name: "image" } },
  ]
  public defaultQuestionEn: Question[] = [
    {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.Multi, name: "multi" }
      , optionsList: {
        guid: ""
        , answerOptionItem: [
          { guid: "", name: "", optionsListGuid: "" }]
      }
    }, {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.Autocomplete, name: "autocomplete" }
      , optionsList: {
        guid: ""
        , answerOptionItem: [
          { guid: "", name: "", optionsListGuid: "" }]
      }
    },
    {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.Mark, name: "mark" }
      , optionsList: {
        guid: ""
        , answerOptionItem: [
          { guid: "", name: "", optionsListGuid: "" }]
      }
    },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.FreeText, name: "freeText" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Number, name: "number" } },
    {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.Table, name: "table" },
      columns: [
        { order: 1, title: "column 1" },
        { order: 2, title: "column 2" },
      ],
      rows: [
        { order: 1, title: "row 1" },
        { order: 2, title: "row 2" },
      ]
    },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.PhoneNumber, name: "phoneNumber" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Range, name: "range" }, fromNum: 1, toNum: 10 },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Title, name: "title" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Text, name: "text" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Link, name: "link" }, title: "" },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.UploadFile, name: "uploadfile" }, title: "Click to add a file or drag a file here" },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.UploadFileAdmin, name: "uploadfileAdmin", title: "Upload file" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Fill, name: "fill" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Divider, name: "divider" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Date, name: "date" } },
    {
      id: 0, status: EStatus.Created, type: { id: EQuestionType.QuestionsGroup, name: "questionsGroup" }, fromNum: 3,
      modularQuestions: [
        { guid: '', type: { id: EQuestionType.Fill, name: "fill", en: "Fill In the Blank", title: "שדה מילוי" , image:"fill.svg" }, status: EStatus.Created, },
      ]
    },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Signature, name: "signature" } },
    { id: 0, status: EStatus.Created, type: { id: EQuestionType.Image, name: "image" }, statusImage: EImageStatus.Created },
  ]
  getDefaultePageName = (index: number) => {
    const lang = this.#translate.instant('header.langCode')
    if (lang != 'en')
      return `page ${index}`
    return `עמוד ${index}`;
  }
  getDefaulteNewOption = () => {
    const lang = this.#translate.instant('header.langCode')
    if (lang != 'en')
      return `New Option`
    return `אפשרות חדשה`;
  }

  getQuestionFromDefaulteArrByType = (type: EQuestionType):Question| undefined => {
    var question = this.defaultQuestionHe.find(q => q.type.id == type);
    if (environment.lang == "en") {
      question = this.defaultQuestionEn.find(q => q.type.id == type);
    }
    if (question) {
      return this.changeGuidsOfQuestions(question).question;
    }
    else return question;
  }
  changeGuidsOfQuestions(question: Question): ChangeGuidRespons {
    var mapGuidsArr = [] as mapGuids[];
    //in question from collletion
    var followQuestions = question.followQuestions?.map(q =>this.changeGuidsOfQuestions(q).question);
    if (question.type.id == EQuestionType.Mark || question.type.id == EQuestionType.Autocomplete || question.type.id == EQuestionType.Multi) {
      if (question.optionsList?.isPublic == true) {
        return { question: { ...question, followQuestions } } as ChangeGuidRespons;
      }
      else {
        var guidOfList = this.#uuidService.generateUUID();
        mapGuidsArr=[...mapGuidsArr,{previousGuid:question.optionsList?.guid,newGuid:guidOfList}as mapGuids]
        var mapQuestionWithGuids =
          {
            ...question,
            optionsList: {
              ...question?.optionsList, guid: guidOfList,
              answerOptionItem: [...question?.optionsList?.answerOptionItem?.map(ans => {
                var guid = this.#uuidService.generateUUID();
                mapGuidsArr=[...mapGuidsArr,{previousGuid:ans.guid,newGuid:guid}as mapGuids]
                followQuestions = followQuestions?.map((q) => { return q.followAnswerOptionItemGuid == ans.guid ? { ...q, followAnswerOptionItemGuid: guid } : q })
                return { guid, optionsListGuid: guidOfList, name: ans.name }
              }) ?? []]
            }
          } as Question;
        return { question: { ...mapQuestionWithGuids, followQuestions } ,mapGuids:mapGuidsArr} as ChangeGuidRespons;
      }
    }
    if (question.type.id == EQuestionType.QuestionsGroup) {
      var mapQuestionWithGuids =
        {
          ...question,
          modularQuestions: [...question?.modularQuestions?.map(mq => { return { ...mq, guid: this.#uuidService.generateUUID() } }) ?? []]
        } as Question;
      return { question: { ...mapQuestionWithGuids, followQuestions } } as ChangeGuidRespons;
    }
    return { question: { ...question, followQuestions } } as ChangeGuidRespons;
  }
  getNamesListForFilter(): Observable<User[]> {
    return this.#httpservice.get<User[]>(`${this.#specificUrl}/getCreatorNamesList`)
  }
  getQuestionTypes = () => { return this.#httpservice.get<QuestionType[]>(`${this.#specificUrl}/getQuestionsType`); }
  getQuestionTypesToModulsrQuestion = () => { return this.#httpservice.get<QuestionType[]>(`${this.#specificUrl}/getForModularQuestion`); }
  getCategories = () => { return this.#httpservice.get<QuestionnaireCategoryCountDto[]>(`${this.#specificUrl}/getCategories`); }
  getAllCategories = () => { return this.#httpservice.get<QuestionnaireCategory[]>(`${this.#specificUrl}/getAllCategories`); }
  getExposureFields = () => { return this.#httpservice.get<any[]>(`${this.#specificUrl}/getExposureFields`); }
  getTableFields = () => { return this.#httpservice.get<TableFieldDto[]>(`${this.#specificUrl}/getTableFields`); }
  logOut = () => { return this.#httpservice.get(`${this.#specificUrl}/logOut`); }
  

  generateGuid(): string {
    // Simple implementation of GUID generation
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  getApprovers = ()=>{return this.#httpservice.get<User[]>(`${this.#specificUrl}/getApprovers`);}
  getCountApprovals = ()=>{return this.#httpservice.get<number>(`${this.#specificUrl}/getCountApprovals`);}
}
// , title: "שדה מילוי", category: 2, image: "fill.svg", en: "Fill In the Blank" 
